<template>
    <div>店铺装修</div>
</template>

<script>
    export default {
        name: "StoreDecorate"
    }
</script>

<style scoped>

</style>